import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Button from "components/CustomButtons/Button.jsx";
import Check from "@material-ui/icons/Check";

// core components
import cardIconStyle from "assets/jss/material-dashboard-pro-react/components/cardActionStyle.jsx";

function CardAction({ ...props }) {
  const { classes, className, children, color, ...rest } = props;
  const cardIconClasses = classNames({
    [classes.cardAction]: true,
    
    [className]: className !== undefined
  });


  return (
    <div className={cardIconClasses} >
      {children}
    </div>
  );
}

CardAction.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose",
    "white"
  ])
};

export default withStyles(cardIconStyle)(CardAction);


